import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import FormTitle from '@src/mobile/layout/Component/FormTitle';
import FormInput from '@src/mobile/layout/Component/FormInput';
import FormSelect from '@src/mobile/layout/Component/FormSelect';
// import { countryNameList } from './country';

const Required = ({ formData, setFormDataHandle, warningTextList }) => {
    
    const changeInputHandle = (key, value) => {
        setFormDataHandle(key, value);
    };

    return (
        <div className={styles.onlineSignUp}>
            <div className={styles.formList}>
                <div className={styles.formListBox}>
                    <FormTitle name="name" title="姓名" warningText={warningTextList['name']} isRequired={true} />
                    <FormInput name="name" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormTitle name="gender" title="性別" warningText={warningTextList['gender']} isRequired={true} />
                    <FormSelect
                        name="gender"
                        formData={formData}
                        changeInputHandle={changeInputHandle}
                        optionValueList={['男', '女']}
                    />
                    <FormTitle title="年龄" name="age" warningText={warningTextList['age']} isRequired={true} />
                    <FormInput name="age" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormTitle name="major" title="单位/职业" warningText={warningTextList['major']} isRequired={true} />
                    <div className={styles.picInfo}>所在单位（若有）/自由职业（若有）/经纪约所在公司（若有)<br />其他情况请如实填写</div>
                    <FormInput name="major" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormTitle
                        name="contact_details"
                        title="联系方式"
                        warningText={warningTextList['contact_details']}
                        isRequired={true}
                    />
                    <FormInput
                        name="contact_details"
                        formData={formData}
                        placeholder="邮箱/手机号/微信号/QQ号等"
                        changeInputHandle={changeInputHandle}
                    />
                </div>
            </div>
        </div>
    );
};

Required.propTypes = {
    formData: PropTypes.object,
    setFormDataHandle: PropTypes.func,
    warningTextList: PropTypes.object,
};

export default errorBoundary(Required);
